var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Send Notification Issue","button-type":'success',"button-text":'Send',"button-status":_vm.sending,"show":_vm.setShow},on:{"update:show":function($event){_vm.setShow=$event},"confirm":_vm.sendNotification}},[_c('p',[_vm._v("Proceed to send notification to all resolvers?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }